"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClassifyModalSearch = void 0;
const react_1 = __importDefault(require("react"));
const search_styles_1 = require("./search.styles");
const localization_1 = require("../../../../../localization");
const ClassifyModalSearch = ({ searchQuery, onSearch }) => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const handleSearch = (e) => {
        var _a;
        const query = (_a = e.currentTarget.value) !== null && _a !== void 0 ? _a : '';
        onSearch(query);
    };
    const handleClear = () => {
        onSearch('');
    };
    return (react_1.default.createElement(search_styles_1.StyledSearchInput, { placeholder: t({ key: 'SEARCH' }), searchInputValue: searchQuery, handleInputChange: handleSearch, handleInputClear: handleClear }));
};
exports.ClassifyModalSearch = ClassifyModalSearch;
exports.default = exports.ClassifyModalSearch;
